<template>
    <div class="d-flex flex-column flex-md-row bg-light">
      <main class="flex-fill p-4 mt-5 mt-md-0">
        <h1 class="h3 fw-bold mb-4">Storyboard Scenes</h1>
        <p class="text-muted mb-4">Storyboard scenes are like a visual script — each frame captures the key action, mood, and flow, so everyone can 'see' the story before it's shot</p>
        <slot />
      </main>
    </div>

    <div>
      


      <!-- Draggable grid -->
      <div class="scenes-scroll">
  <div class="row g-3">
    <div
      class="col-md-4 col-sm-6"
      v-for="scene in scenes"
      :key="scene.id || scene.number"
    >
      <div class="card h-100 border rounded-4 p-3">
        <!-- Top Row -->
        <div class="d-flex justify-content-between align-items-start mb-2">
          <span class="badge rounded-pill text-dark border">
            Scene {{ scene.number }}
          </span>
          <div class="d-flex align-items-center gap-2">
            <!-- If you want these icons, import & register them first -->
            <!-- <GripVertical class="text-muted" :size="18" style="cursor:grab" /> -->
            <!-- <Trash2 :size="18" style="cursor:pointer" @click="deleteScene(scene)" /> -->
          </div>
        </div>

        <!-- Title -->
        <h6 class="fw-semibold">{{ scene.title }}</h6>

        <!-- Video -->
        <div class="d-flex justify-content-center align-items-center bg-light rounded-3 my-3" style="height:300px;">
          <video
            v-if="scene.videoUrl"
            :src="scene.videoUrl"
            style="height:100%; width:100%; object-fit:cover; border-radius:.5rem;"
            controls
            playsinline
          ></video>
          <div v-else class="text-muted small">No video</div>
        </div>

        <!-- Description -->
        <p class="small text-muted">{{ scene.description }}</p>

        <!-- Duration -->
        <div class="d-flex justify-content-end">
          <span class="badge rounded-pill bg-info text-white">
            {{ scene.duration }}s
          </span>
        </div>
      </div>
    </div>
  </div>
</div>


    </div>
    
</template>

<script>
import axios from "axios";
import { useToast } from 'vue-toastification'

export default {
  name: 'Storyboard',
  // components: { , GripVertical, Trash2 },
  data() {
    return {
      // scenes: [
      //   { id: 1, number: 1, title: 'Hook - Problem Statement', videoUrl:"https://firebasestorage.googleapis.com/v0/b/werkmarketingtool.firebasestorage.app/o/6026114_Person_People_3840x2160.mp4?alt=media&token=29bccc80-81ef-4fc3-83e3-bee8d133fd75", description: 'Customer frustrated with slow support response times', duration: 3 },
      //   { id: 2, number: 2, title: 'Solution Introduction', videoUrl:"https://firebasestorage.googleapis.com/v0/b/werkmarketingtool.firebasestorage.app/o/14163920_1920_1080_30fps.mp4?alt=media&token=54c66873-5b67-4fb3-920e-6cb817821bed", description: "Introduce TechFlow's AI-powered instant support", duration: 4 },
      //   { id: 3, number: 3, title: 'Demo - Real-time Response', videoUrl: "https://firebasestorage.googleapis.com/v0/b/werkmarketingtool.firebasestorage.app/o/14163920_1920_1080_30fps.mp4?alt=media&token=54c66873-5b67-4fb3-920e-6cb817821bed", description: 'Show AI responding to customer query in real-time', duration: 6 },
      //   { id: 4, number: 4, title: 'Customer Satisfaction', videoUrl: "https://firebasestorage.googleapis.com/v0/b/werkmarketingtool.firebasestorage.app/o/13948810_3840_2160_50fps.mp4?alt=media&token=ef01ceaa-50eb-4c48-8fab-4b3d7357fb0d", description: 'Happy customer receiving instant, accurate help', duration: 3 },
      //   { id: 5, number: 5, title: 'Call to Action', videoUrl: "https://firebasestorage.googleapis.com/v0/b/werkmarketingtool.firebasestorage.app/o/12472746_1920_1080_24fps.mp4?alt=media&token=5cbac7d4-eb1b-43a4-be81-470396e30f41", description: "Learn more about TechFlow's AI solutions", duration: 2 }
      // ],
      ideaId:"",
      scenes: [],
      // apiURL: "https://genstoryflow-backend-main-build-353838813175.europe-west1.run.app",
      // apiURL: "http://127.0.0.1:5001",
      apiURL: "https://genstoryflow-backend-main-build-353838813175.europe-west1.run.app",
    }
  },
  setup() {
    const toast = useToast()

    return {
      toast
    }
  },
    async mounted(){
      this.ideaId = this.$route.params.id
      await this.refreshScenes()
  },
  methods: {
     
    async refreshScenes() {
      if (!this.ideaId) return
      this.isLoading = true
      this.loadError = ''
      try {
        const res = await axios.get(`${this.apiURL}/getStoryboardsClient`, {
          params: { ideaID: this.ideaId },          
        })

        // make sure res.data and res.data.data exist
        let rows = (res && res.data && Array.isArray(res.data.data))
          ? res.data.data
          : []

        // Already ordered by SceneNumber from backend, but we sanitize anyway
        rows.sort(function (a, b) {
          var aNum = (a && a.SceneNumber != null) ? a.SceneNumber : 0
          var bNum = (b && b.SceneNumber != null) ? b.SceneNumber : 0
          return aNum - bNum
        })

        this.scenes = rows.map(function (d, i) {
          var sceneNum = (d && d.SceneNumber != null) ? d.SceneNumber : (i + 1)
          return {
            id: d.id,
            number: sceneNum,
            title: d.Title || ('Scene ' + sceneNum),  // fallback if no Title
            description: d.Description || '',
            imageUrl: d.ImageUrl || '',               // backend can add this later
            videoUrl: d.VideoUrl || '',
            duration: (d.Duration != null) ? d.Duration : 3
          }
        })


        // tidy numbers + snapshot
        this.scenes.forEach((s, i) => (s.number = i + 1))
        this.lastSavedOrder = this.scenes.map(s => s.id)
      } catch (err) {
        console.error(err)
        this.loadError = 'Cannot load storyboards, try again later.'
      } finally {
        this.isLoading = false
      }
    },
    

    
  },
  computed: {
  }
}
</script>

<style scoped>
.card { transition: box-shadow 0.2s; }
.card:hover { box-shadow: 0 4px 20px rgba(0,0,0,0.08); }
/* optional nicer grabbing cursor while dragging */
.drag-handle:active { cursor: grabbing !important; }.scenes-scroll {
  max-height: 70vh; /* adjust so it fits nicely in your layout */
  overflow-y: auto;
  padding-right: 8px; /* for scrollbar spacing */
}

/* Optional: nicer thin scrollbar */
.scenes-scroll::-webkit-scrollbar {
  width: 6px;
}
.scenes-scroll::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}

</style>
